export const MAX_PRODUCTS = 3;

export const MAX_PRODUCTS_STYLE = 3;

export const PRODUCT_SLOT_WIDTH = 163;

export const PRODUCT_SLOT_GAP = 16; // Gap between product slots
